module.exports = __webpack_public_path__ + "static/media/CT Text Logo-2.344f8f28.png";